<div class="item-with-icon-and-owner">
  <div class="item-icon-wrapper">
    <i class="sp-mr-10 fs-16px" [uiType]="icon" ui-icon uiTheme="fill"></i>
    <p class="item-name fs-12px" tabindex="0">{{ name }}</p>
  </div>
  <ui-assignee-avatar-group *ngIf="ownerIds" [uiMax]="2" [uiAlignRight]="true" uiSize="xs">
    <ui-assignee-avatar *ngFor="let assigneeId of ownerIds" [fromAssigneeId]="assigneeId" />
  </ui-assignee-avatar-group>
</div>
